import React, { useEffect, useState } from 'react';

const defaultProps = {
    initialPage: 1,
    pageSize: 5
}

const Pagination = props => {
    
    const [pager, setPager] = useState({});
    const [pageSize, setPageSize] = useState(defaultProps.pageSize);
    
    useEffect(() => {
        // setPage if items array isn't empty
        if (props.pageSize)
        {
            setPageSize(props.pageSize);
        }
        if (props.items && props.items.length)
        {
            setPage(props.initialPage);
        }
    }, [])

    useEffect(() => {
        // Resets if items array has changed
        setPage(props.initialPage);
    }, [props.items])
    
    const setPage = (page) => {
        let items = props.items || [];

        // get new paper object for specified page
        let pager = getPager(items.length, page);

        // get new page of items from items array
        let pageOfItems = items.slice(pager.startIndex, pager.endIndex + 1);

        // update state
        setPager(pager);

        // call change page function in parent component
        props.onChangePage(pageOfItems);
    }

    const getPager = (totalItems, pCurrentPage, pPageSize) => {
        let currentPage = pCurrentPage || 1;

        let pageSizeValue = pPageSize || pageSize;

        // calculate total pages
        let totalPages = Math.ceil(totalItems / pageSizeValue);

        let startPage;
        let endPage;

       if (totalPages <= 5) {
            // less than 5
            startPage = 1;
            endPage = totalPages
        } else {
            // More than 10
            if (currentPage <= 6) {
                startPage = 1;
                endPage = 10;
            } else if (currentPage + 4 >= totalPages) {
                startPage = totalPages - 9;
                endPage = totalPages;
            } else {
                startPage = currentPage - 5;
                endPage = currentPage + 4
            }
        }

        // calculate end and start page
        let startIndex = (currentPage - 1) * pageSizeValue;
        let endIndex = Math.min(startIndex + pageSizeValue - 1, totalItems - 1);

        let pages = [...Array((endPage + 1 ) - startPage).keys()].map((i) => startPage + i);

        return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSizeValue,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            pages: pages
        }
    }

    return (
        <div className="pagination--wrapper" >
            {props.items && props.items.length > 0 && (
                <div className="pagination--elements">
                    <ul className="main-color">
                        <li role="button" className={`arrow firstpage ${pager.currentPage > 1 ? '' : 'invisible'}`} onClick={() => setPage(setPage(1))}><span><i className="fa fa-angle-double-left" aria-hidden="true"></i></span></li>
                        <li role="button" className={`arrow previouspage ${pager.currentPage > 1 ? '' : 'invisible'}`} onClick={() => setPage(pager.currentPage - 1)} ><span><i className="fa fa-angle-left" aria-hidden="true"></i></span></li>
                        <li><span className="">{`${pager.currentPage}/${pager.totalPages}`}</span></li>
                        <li role="button" className={`arrow nextpage ${pager.currentPage == pager.totalPages ? 'invisible' : ''}`} onClick={() => setPage(pager.currentPage + 1)} ><span><i className="fa fa-angle-right" aria-hidden="true"></i></span></li>
                        <li role="button" className={`arrow lastpage ${pager.currentPage == pager.totalPages ? 'invisible' : ''}`} onClick={() => setPage(pager.totalPages)} ><span><i className="fa fa-angle-double-right" aria-hidden="true"></i></span></li>
                    </ul>
                {/* PAGINATION TEXT */}
                    {!!props.items.length > 0 && (
                    <div className="pag-numbers" ><span className="">{`Displaying ${pager.startIndex + 1}-${pager.endIndex + 1} of ${props.items.length}`}</span></div>
                )}
            </div>
            )}
        </div>
    );
}

Pagination.defaultProps = defaultProps;

export default Pagination;